var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseButton = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.273 6.0002L11.1191 2.15407L11.9123 1.36092C12.0292 1.24392 12.0292 1.05378 11.9123 0.936781L11.0636 0.0881279C10.9466 -0.0288759 10.7565 -0.0288759 10.6395 0.0881279L6.00021 4.72741L1.36093 0.0877529C1.24389 -0.029251 1.05379 -0.029251 0.93679 0.0877529L0.0877248 0.936406C-0.0292416 1.05341 -0.0292416 1.24354 0.0877248 1.36054L4.72741 6.0002L0.0877248 10.6395C-0.0292416 10.7565 -0.0292416 10.9466 0.0877248 11.0636L0.936415 11.9123C1.05338 12.0293 1.24355 12.0293 1.36052 11.9123L6.00021 7.27299L9.8463 11.1191L10.6395 11.9123C10.7565 12.0293 10.9466 12.0293 11.0636 11.9123L11.9123 11.0636C12.0292 10.9466 12.0292 10.7565 11.9123 10.6395L7.273 6.0002Z",
    fill: "#242A42"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-button.2bbecba3628837a55bacc44113ee1a32.svg";